export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_10-322e9eae7cc0a2123a6cbd8460f5b5b5.jpg";